export default __webpack_public_path__ + "static/media/share-grey-16px.814aabdb.svg";